import React from 'react';
import PropTypes from 'prop-types';
import PriceHistory from '../../../product/components/price-history';

import * as S from '../../styles';

const PriceTrend = props => {
  const { product, withoutGraph } = props;

  const futurePrices =
    product.priceForecast && product.priceForecast.length > 0
      ? product.priceForecast
      : [];

  return (
    <S.Section
      style={{
        borderTop: 'none',
        marginTop: '10px',
        paddingTop: '0px',
        marginBottom: '0px',
      }}
    >
      {!withoutGraph && (
        <PriceHistory
          graphOnly
          {...product.statistics}
          predictedPrices={futurePrices}
          preRelease={product.priceForecast && product.priceForecast.length > 0}
          releaseDate={product.releaseDate}
        />
      )}
    </S.Section>
  );
};

PriceTrend.propTypes = {
  product: PropTypes.object.isRequired, // eslint-disable-line
  withoutGraph: PropTypes.bool,
};

PriceTrend.defaultProps = {
  withoutGraph: false,
};

export default PriceTrend;
